module.exports = __webpack_public_path__ + "img/bicom_logo.73c13484.png";